<template>
  <div>
    <div class="block block-message my-4 ws-textbox">
      <div class="d-flex justify-content-between">
        <div class="w-50">
          <div v-for="pax in groupPax" :key="pax.id" class="pax-fullname">
            {{ pax.first_name + ' ' + pax.last_name }}
          </div>
        </div>
        <div>
          <div v-for="pax in groupPax" :key="pax.id">PNR: {{ pax.pnr }}</div>
        </div>
      </div>
    </div>
    <div class="mb-4">
      <FlightInfo :flight="flight" />
    </div>
    <div class="block block-form-confirm">
      <div>
        <form class="form-horizontal form-content-confirm ws-textbox" @submit.prevent="confirmDetails()">
          <div class="">
            <p>
              <!-- SFS_LANG_ROW_19: Mobile phone number -->
              {{ lang['virtual_helpdesk_new'].SFS_LANG_ROW_19 }}
            </p>
            <div>
              <span class="normal-text">
                <!-- SFS_LANG_ROW_20: Select country code and add your phone number -->
                {{ lang['virtual_helpdesk_new'].SFS_LANG_ROW_20 }}
              </span>
            </div>
            <div class="control-group">
              <VueTelInput
                v-model.trim="phonePax"
                v-bind="{ required: false, placeholder: lang['virtual_helpdesk_new'].SFS_LANG_ROW_38 || 'Enter a phone number' }"
                :class="{ 'validation-failed': !validatePhone }"
                @input="onInput"
              ></VueTelInput>
            </div>
          </div>
          <div class="text-center">
            <span>{{ lang['virtual_helpdesk_new'].SFS_LANG_ROW_4 || 'Or' }}</span>
          </div>
          <div class="mb-3">
            <p>
              <!-- SFS_LANG_ROW_21: Email address -->
              {{ lang['virtual_helpdesk_new'].SFS_LANG_ROW_21 }}
            </p>
            <input
              id="email-address"
              v-model.trim="emailPax"
              type="email"
              class="form-control email-pax"
              :placeholder="lang['virtual_helpdesk_new'].SFS_LANG_ROW_39 || 'Enter email address'"
            />
          </div>
          <div class="input-group text-center d-block">
            <button type="submit" class="ws-btn hd-normal-btn-color">
              <!-- SFS_LANG_ROW_18: Confirm -->
              {{ lang['virtual_helpdesk_new'].SFS_LANG_ROW_18 }}
            </button>
          </div>
        </form>
        <b-modal v-model="isOpenPopup" :modal-class="'ws-modal'" centered hide-footer hide-header>
          <div class="d-flex justify-content-center align-items-center flex-column py-5">
            <div class="icon-confirm-success">
              <i :class="[message.icon]"></i>
            </div>
            <div class="mt-3 h5 msg-text" v-html="message.text"></div>
          </div>
        </b-modal>
      </div>
    </div>
  </div>
</template>
<script>
import 'vue-tel-input/dist/vue-tel-input.css'
import { replaceStr } from '@/utils/helper'
import VueTelInput from 'vue-tel-input'
import FlightInfo from '@/components/FlightInfo/index'

export default {
  components: { VueTelInput, FlightInfo },
  props: {
    token: {
      type: String,
      default: ''
    },
    paxThisIsMe: {
      type: Object,
      default: () => {}
    },
    flight: {
      type: Object,
      default: () => {}
    }
  },
  data() {
    return {
      phonePax: '',
      emailPax: '',
      groupPax: [],
      isAmadeus: false,
      checkConfirm: false,
      validatePhone: true,
      isOpenPopup: false,
      message: {
        icon: '',
        text: ''
      }
    }
  },
  watch: {
    paxThisIsMe: {
      handler(val) {
        this.setDataPaxGroup()
      },
      deep: true
    }
  },
  mounted() {
    this.setDataPaxGroup()
  },
  created() {
    this.parserLang()
  },
  methods: {
    replaceStr,
    confirmDetails: function () {
      let self = this
      if (!self.validatePhone) {
        self.$swal(self.lang['virtual_helpdesk_new']?.SFS_LANG_ROW_40 || 'The number phone invalid')
        return
      }
      if (self.emailPax.trim().length > 0 && !self.validateEmail()) {
        self.$swal(self.lang['virtual_helpdesk_new']?.SFS_LANG_ROW_41 || 'The email invalid')
        return
      }
      if (self.emailPax.trim().length == 0 && self.phonePax.trim().length == 0) {
        self.$swal(self.lang['virtual_helpdesk_new']?.SFS_LANG_ROW_42 || 'Please enter your phone or email')
        return
      }
      self.groupPax = new Array()
      _.forEach(_.cloneDeep(self.paxThisIsMe.groups), (pax) => {
        if (pax.id == self.paxThisIsMe.id) {
          pax.it_me = true
          pax.phone_number = self.phonePax ? self.phonePax : ''
          pax.email_address = self.emailPax ? self.emailPax : ''
        } else {
          pax.it_me = false
        }
        pax.care_for = true
        pax = _.omit(pax, ['groups'])
        self.groupPax.push(pax)
      })
      // removes duplicate objects from the self.groupPax array based on their 'id'
      self.groupPax = _.uniqBy(self.groupPax, 'id')
      let dataSend = {
        data: {
          phone_number: self.phonePax,
          email: self.emailPax,
          list_paxs: self.groupPax
        },
        airline_token_virtual_helpdesk: self.token
      }
      if (self.paxThisIsMe.amadeus_virtual_desk) {
        dataSend.data.amadeus_virtual_desk = self.paxThisIsMe.amadeus_virtual_desk
      }
      self.$store
        .dispatch('VirtualHelpdesk/confirmDetails', dataSend)
        .then(function (res) {
          self.$emit('updatePhone', self.phonePax)
          if (res.success) {
            self.isOpenPopup = true
            self.$set(self.message, 'icon', 'fas fa-check-circle text-success')
            const msg = replaceStr(self.lang['virtual_helpdesk_new'].SFS_LANG_ROW_36, ['<airline>'], self.airline.name)
            self.$set(self.message, 'text', msg)
          } else {
            if (!_.isArray(res.message) && res.message.length > 0) {
              self.$swal(res.message)
            } else {
              self.$swal('Fail!')
            }
          }
        })
        .catch((error) => {
          console.log(error)
          self.isOpenPopup = true
          self.$set(self.message, 'icon', 'far fa-times-circle danger')
          self.$set(self.message, 'text', 'Fail')
        })
    },
    onInput(formattedNumber, { number, isValid, country }) {
      if (number.input == '00' || number.input == '+00') {
        this.phonePax = '+'
      } else if (number.international) {
        this.phonePax = number.international
      }
      this.validatePhone = isValid
      if (!formattedNumber) {
        this.validatePhone = true
      }
    },
    setDataPaxGroup() {
      let self = this
      if (self.paxThisIsMe) {
        self.groupPax = self.paxThisIsMe.groups
        if (self.paxThisIsMe.source == 'AMADEUS') {
          self.isAmadeus = true
        }
        // removes duplicate objects from the self.groupPax array based on their 'id'
        self.groupPax = _.uniqBy(self.groupPax, 'id')
        self.phonePax = self.paxThisIsMe.phone_number
        self.emailPax = self.paxThisIsMe.email_address
      }
    },
    validateEmail() {
      return String(this.emailPax.trim())
        .toLowerCase()
        .match(
          /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/
        )
    },
    parserLang() {
      let airline_lang = this.airline.lang_config
      if (!_.isEmpty(airline_lang)) {
        for (let prop in airline_lang) {
          airline_lang[prop].CONFIG = JSON.parse(airline_lang[prop].CONFIG)
        }
        return airline_lang
      }
    }
  }
}
</script>
<style lang="scss" scoped>
.vue-tel-input {
  background: #fafafa;
  input {
    background: #fafafa;
  }
}
::v-deep .icon-confirm-success {
  font-size: 20px;
  i {
    font-size: 60px;
  }
}
.pax-fullname {
  display: -webkit-box;
  -webkit-box-orient: vertical;
  -webkit-line-clamp: 1;
  overflow: hidden;
}

.textbox-title {
  color: #474747;
  font-weight: 400;
  font-size: 16px;
}
.normal-text {
  font-size: 13px;
}
.email-pax {
  font-size: 14px;
}
.msg-text {
  text-align: center;
}
</style>
